import React, { useState } from 'react';

const MonthlyIncome = ({ onNext, answers, stepKey }) => {
  const [error, setError] = useState('');
  const [income, setIncome] = useState(answers[stepKey] || '');

  const handleContinue = () => {
    if (!income) {
      setError('This field is required');
      return;
    }
    if (!/^[0-9]+$/.test(income)) {
      setError('Only numbers are allowed');
      return;
    }
    setError('');
    onNext(income);
  };

  const handleChange = (e) => {
    setIncome(e.target.value);
    if (error) {
      setError('');
    }
  };

  return (
    <>
      <div className="qs-card__head">
        <h2 className="qs-card__title">
          Income at Time of Application
        </h2>
      </div>
      <div className="qs-card__body">
        <p className="qs-card__sub">What was your <strong style={{ fontWeight: '900', color: '#000' }}>monthly</strong> income (after tax) at the time of taking the credit card?</p>
        <div className="qs-money-wrap">
          <div className="qs-money-field">
            <i>£</i>
            <input
              type="text"
              className="qs-money"
              placeholder="Enter Amount"
              id="monthlyIncome"
              autoComplete="off"
              maxLength={20}
              value={income}
              onChange={handleChange}
            />
          </div>
          <div className="qs-help"><i className="bi bi-piggy-bank"></i><span>Please provide your best estimate if you're unsure of the exact amount</span></div>
        </div>
        {error && <p className="qs-error-message" style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
        <div className="qs-actions"><button type="button" className="qs-btn qs-btn--primary" onClick={handleContinue}>Continue <span className="qs-arrow">→</span></button></div>
      </div>
    </>
  );
};

export default MonthlyIncome;
